interface ITranslationResponse
{
	translatedText: string
}

export default class Translate
{
	static async translate(s: string, locale: string, cb: Function)
	{
		if (s)
		{
			const gc = require("google-translate")("AIzaSyC4S6zib381PSWXhVcGV482lQ4o0ZzhcTg");

			gc.translate(s, locale.substr(0, 2), (err: any, response: ITranslationResponse) =>
			{
				cb(response.translatedText);
			});
		}
		else
		{
			cb("");
		}
	}
}
